module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_location-b61e264bfbe66a4ba0591ad2f0ffbad8.webp";